import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class JobenquiryService extends GenericService {
  constructor() {
    super('/job_enquiries', axiosInstance);
  }
}

export default new JobenquiryService(); 